import { useState } from 'react';
import { createPortal } from 'react-dom';
import { MoreHorizontal } from 'lucide-react';
import { C } from './tokens';

// Mobile bottom navigation: Overview + Projects always shown, plus a
// "Menu" button that opens a bottom sheet of all other visible tabs.
export const BottomNav = ({ tabs, tab, setTab, iconByTab }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const FOOTER_TABS = ["Overview", "Projects"].filter(t => tabs.includes(t));
  const menuTabs = tabs.filter(t => t !== "Overview" && t !== "Projects");
  const menuActive = !["Overview", "Projects"].includes(tab);

  const navItem = (key, isActive, onClick, IconComp, label) => (
    <button key={key} onClick={onClick} style={{
      flex: 1, background: "none", border: "none", padding: "12px 4px 10px",
      display: "flex", flexDirection: "column", alignItems: "center", gap: 4,
      cursor: "pointer",
    }}>
      <span style={{ color: isActive ? "#FFFFFF" : "rgba(255,255,255,.45)", display: "flex" }}>
        {IconComp ? <IconComp size={20} strokeWidth={2} /> : <span style={{ fontSize: 20 }}>○</span>}
      </span>
      <span style={{
        fontFamily: "'Jost',system-ui,sans-serif", fontSize: 10,
        color: isActive ? "#FFFFFF" : "rgba(255,255,255,.5)",
        fontWeight: isActive ? 700 : 400, textTransform: "uppercase", letterSpacing: ".06em",
      }}>{label}</span>
      {isActive && <div style={{ width: 20, height: 2, background: "#FFFFFF", borderRadius: 1, marginTop: 2 }} />}
    </button>
  );

  return (
    <>
      <div style={{
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 50,
        background: "#1E3A5F", borderTop: "2px solid #2D5282",
        display: "flex", paddingBottom: "env(safe-area-inset-bottom)",
        boxShadow: "0 -4px 20px rgba(0,0,0,.25)",
      }}>
        {FOOTER_TABS.map(t => navItem(t, tab === t, () => setTab(t), iconByTab?.[t], t))}
        {menuTabs.length > 0 && navItem("__menu", menuActive, () => setMenuOpen(true), MoreHorizontal, "Menu")}
      </div>

      {menuOpen && createPortal(
        <>
          <div onClick={() => setMenuOpen(false)} style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 2000,
          }} />
          <div onClick={e => e.stopPropagation()} style={{
            position: "fixed", bottom: 0, left: 0, right: 0,
            background: "#1E3A5F", borderRadius: "18px 18px 0 0",
            paddingBottom: "calc(14px + env(safe-area-inset-bottom))", zIndex: 2001,
            maxHeight: "60vh", overflowY: "auto",
          }}>
            <div style={{ width: 36, height: 4, background: "rgba(255,255,255,.3)", borderRadius: 2, margin: "10px auto 8px" }} />
            {menuTabs.map(t => {
              const IconComp = iconByTab?.[t];
              const isActive = tab === t;
              return (
                <button key={t} onClick={() => { setTab(t); setMenuOpen(false); }} style={{
                  width: "100%", background: isActive ? "rgba(255,255,255,.08)" : "none", border: "none",
                  padding: "0 24px", height: 56, display: "flex", alignItems: "center", gap: 14,
                  cursor: "pointer", color: isActive ? "#FFFFFF" : "rgba(255,255,255,.75)",
                }}>
                  {IconComp ? <IconComp size={20} strokeWidth={2} /> : <span style={{ fontSize: 20 }}>○</span>}
                  <span style={{
                    fontFamily: "'Jost',system-ui,sans-serif", fontSize: 15,
                    fontWeight: isActive ? 700 : 500, textTransform: "uppercase", letterSpacing: ".04em",
                  }}>{t}</span>
                </button>
              );
            })}
          </div>
        </>,
        document.body
      )}
    </>
  );
};
